module.exports = __webpack_public_path__ + "img/congo.970396f.webp";